// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-banner {
  display: grid;
  flex: 1 1;
  font-size: 0.875rem;
  grid-template-areas: "prepend content actions";
  grid-template-columns: max-content auto max-content;
  grid-template-rows: max-content max-content;
  line-height: 1.6;
  overflow: hidden;
  padding-inline: 16px 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  position: relative;
  width: 100%;
}
:where(.vuetify-styles) .v-banner {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0 0 thin 0;
}
:where(.vuetify-styles) .v-banner--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-banner {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-banner--absolute {
  position: absolute;
}
:where(.vuetify-styles) .v-banner--fixed {
  position: fixed;
}
:where(.vuetify-styles) .v-banner--sticky {
  position: sticky;
}
:where(.vuetify-styles) .v-banner {
  border-radius: 0;
}
:where(.vuetify-styles) .v-banner {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-banner--rounded {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-banner--stacked:not(.v-banner--one-line) {
  grid-template-areas: "prepend content" ". actions";
}
:where(.vuetify-styles) .v-banner--stacked .v-banner-text {
  padding-inline-end: 36px;
}
:where(.vuetify-styles) .v-banner--density-default .v-banner-actions {
  margin-bottom: -8px;
}
:where(.vuetify-styles) .v-banner--density-default.v-banner--one-line {
  padding-top: 8px;
  padding-bottom: 8px;
}
:where(.vuetify-styles) .v-banner--density-default.v-banner--one-line .v-banner-actions {
  margin-bottom: 0;
}
:where(.vuetify-styles) .v-banner--density-default.v-banner--one-line {
  padding-top: 10px;
}
:where(.vuetify-styles) .v-banner--density-default.v-banner--two-line {
  padding-top: 16px;
  padding-bottom: 16px;
}
:where(.vuetify-styles) .v-banner--density-default.v-banner--three-line {
  padding-top: 24px;
  padding-bottom: 16px;
}
:where(.vuetify-styles) .v-banner--density-default:not(.v-banner--one-line) .v-banner-actions, :where(.vuetify-styles) .v-banner--density-default.v-banner--two-line .v-banner-actions, :where(.vuetify-styles) .v-banner--density-default.v-banner--three-line .v-banner-actions {
  margin-top: 20px;
}

:where(.vuetify-styles) .v-banner--density-comfortable .v-banner-actions {
  margin-bottom: -4px;
}
:where(.vuetify-styles) .v-banner--density-comfortable.v-banner--one-line {
  padding-top: 4px;
  padding-bottom: 4px;
}
:where(.vuetify-styles) .v-banner--density-comfortable.v-banner--one-line .v-banner-actions {
  margin-bottom: 0;
}
:where(.vuetify-styles) .v-banner--density-comfortable.v-banner--two-line {
  padding-top: 12px;
  padding-bottom: 12px;
}
:where(.vuetify-styles) .v-banner--density-comfortable.v-banner--three-line {
  padding-top: 20px;
  padding-bottom: 12px;
}
:where(.vuetify-styles) .v-banner--density-comfortable:not(.v-banner--one-line) .v-banner-actions, :where(.vuetify-styles) .v-banner--density-comfortable.v-banner--two-line .v-banner-actions, :where(.vuetify-styles) .v-banner--density-comfortable.v-banner--three-line .v-banner-actions {
  margin-top: 16px;
}

:where(.vuetify-styles) .v-banner--density-compact .v-banner-actions {
  margin-bottom: 0px;
}
:where(.vuetify-styles) .v-banner--density-compact.v-banner--one-line {
  padding-top: 0px;
  padding-bottom: 0px;
}
:where(.vuetify-styles) .v-banner--density-compact.v-banner--one-line .v-banner-actions {
  margin-bottom: 0;
}
:where(.vuetify-styles) .v-banner--density-compact.v-banner--two-line {
  padding-top: 8px;
  padding-bottom: 8px;
}
:where(.vuetify-styles) .v-banner--density-compact.v-banner--three-line {
  padding-top: 16px;
  padding-bottom: 8px;
}
:where(.vuetify-styles) .v-banner--density-compact:not(.v-banner--one-line) .v-banner-actions, :where(.vuetify-styles) .v-banner--density-compact.v-banner--two-line .v-banner-actions, :where(.vuetify-styles) .v-banner--density-compact.v-banner--three-line .v-banner-actions {
  margin-top: 12px;
}

:where(.vuetify-styles) .v-banner--sticky {
  top: 0;
  z-index: 1;
}

:where(.vuetify-styles) .v-banner__content {
  align-items: center;
  display: flex;
  grid-area: content;
}

:where(.vuetify-styles) .v-banner__prepend {
  align-self: flex-start;
  grid-area: prepend;
  margin-inline-end: 24px;
}

:where(.vuetify-styles) .v-banner-actions {
  align-self: flex-end;
  display: flex;
  flex: 0 1;
  grid-area: actions;
  justify-content: flex-end;
}
:where(.vuetify-styles) .v-banner--two-line .v-banner-actions, :where(.vuetify-styles) .v-banner--three-line .v-banner-actions {
  margin-top: 20px;
}

:where(.vuetify-styles) .v-banner-text {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  padding-inline-end: 90px;
  overflow: hidden;
}
:where(.vuetify-styles) .v-banner--one-line .v-banner-text {
  -webkit-line-clamp: 1;
}
:where(.vuetify-styles) .v-banner--two-line .v-banner-text {
  -webkit-line-clamp: 2;
}
:where(.vuetify-styles) .v-banner--three-line .v-banner-text {
  -webkit-line-clamp: 3;
}
:where(.vuetify-styles) .v-banner--two-line .v-banner-text, :where(.vuetify-styles) .v-banner--three-line .v-banner-text {
  align-self: flex-start;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VBanner/VBanner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8CAA8C;EAC9C,mDAAmD;EACnD,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".v-banner {\n  display: grid;\n  flex: 1 1;\n  font-size: 0.875rem;\n  grid-template-areas: \"prepend content actions\";\n  grid-template-columns: max-content auto max-content;\n  grid-template-rows: max-content max-content;\n  line-height: 1.6;\n  overflow: hidden;\n  padding-inline: 16px 8px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  position: relative;\n  width: 100%;\n}\n.v-banner {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0 0 thin 0;\n}\n.v-banner--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-banner {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-banner--absolute {\n  position: absolute;\n}\n.v-banner--fixed {\n  position: fixed;\n}\n.v-banner--sticky {\n  position: sticky;\n}\n.v-banner {\n  border-radius: 0;\n}\n.v-banner {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-banner--rounded {\n  border-radius: 4px;\n}\n.v-banner--stacked:not(.v-banner--one-line) {\n  grid-template-areas: \"prepend content\" \". actions\";\n}\n.v-banner--stacked .v-banner-text {\n  padding-inline-end: 36px;\n}\n.v-banner--density-default .v-banner-actions {\n  margin-bottom: -8px;\n}\n.v-banner--density-default.v-banner--one-line {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.v-banner--density-default.v-banner--one-line .v-banner-actions {\n  margin-bottom: 0;\n}\n.v-banner--density-default.v-banner--one-line {\n  padding-top: 10px;\n}\n.v-banner--density-default.v-banner--two-line {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.v-banner--density-default.v-banner--three-line {\n  padding-top: 24px;\n  padding-bottom: 16px;\n}\n.v-banner--density-default:not(.v-banner--one-line) .v-banner-actions, .v-banner--density-default.v-banner--two-line .v-banner-actions, .v-banner--density-default.v-banner--three-line .v-banner-actions {\n  margin-top: 20px;\n}\n\n.v-banner--density-comfortable .v-banner-actions {\n  margin-bottom: -4px;\n}\n.v-banner--density-comfortable.v-banner--one-line {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.v-banner--density-comfortable.v-banner--one-line .v-banner-actions {\n  margin-bottom: 0;\n}\n.v-banner--density-comfortable.v-banner--two-line {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.v-banner--density-comfortable.v-banner--three-line {\n  padding-top: 20px;\n  padding-bottom: 12px;\n}\n.v-banner--density-comfortable:not(.v-banner--one-line) .v-banner-actions, .v-banner--density-comfortable.v-banner--two-line .v-banner-actions, .v-banner--density-comfortable.v-banner--three-line .v-banner-actions {\n  margin-top: 16px;\n}\n\n.v-banner--density-compact .v-banner-actions {\n  margin-bottom: 0px;\n}\n.v-banner--density-compact.v-banner--one-line {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n.v-banner--density-compact.v-banner--one-line .v-banner-actions {\n  margin-bottom: 0;\n}\n.v-banner--density-compact.v-banner--two-line {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.v-banner--density-compact.v-banner--three-line {\n  padding-top: 16px;\n  padding-bottom: 8px;\n}\n.v-banner--density-compact:not(.v-banner--one-line) .v-banner-actions, .v-banner--density-compact.v-banner--two-line .v-banner-actions, .v-banner--density-compact.v-banner--three-line .v-banner-actions {\n  margin-top: 12px;\n}\n\n.v-banner--sticky {\n  top: 0;\n  z-index: 1;\n}\n\n.v-banner__content {\n  align-items: center;\n  display: flex;\n  grid-area: content;\n}\n\n.v-banner__prepend {\n  align-self: flex-start;\n  grid-area: prepend;\n  margin-inline-end: 24px;\n}\n\n.v-banner-actions {\n  align-self: flex-end;\n  display: flex;\n  flex: 0 1;\n  grid-area: actions;\n  justify-content: flex-end;\n}\n.v-banner--two-line .v-banner-actions, .v-banner--three-line .v-banner-actions {\n  margin-top: 20px;\n}\n\n.v-banner-text {\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  padding-inline-end: 90px;\n  overflow: hidden;\n}\n.v-banner--one-line .v-banner-text {\n  -webkit-line-clamp: 1;\n}\n.v-banner--two-line .v-banner-text {\n  -webkit-line-clamp: 2;\n}\n.v-banner--three-line .v-banner-text {\n  -webkit-line-clamp: 3;\n}\n.v-banner--two-line .v-banner-text, .v-banner--three-line .v-banner-text {\n  align-self: flex-start;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
